<template>
    <v-dialog
        id="program-info-dialog"
        :value="dialog"
        @input="toggleDialog()"
        max-width="700px"
    >
        <v-card v-if="programInfo">
            <v-toolbar 
                height="40" 
                flat
            >
                <v-spacer></v-spacer>
                <v-btn 
                    icon 
                    @click.prevent="toggleDialog()"
                    :ripple="false"
                >
                    <v-icon color="black">
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <div class="px-6 pb-7">
                <div class="text-center h2 pb-4 font-weight-black">
                    {{ $t('utils.information')}}
                </div>
                <!-- DESCRIPTION -->
                <div class="text-center">
                    <span 
                        v-if="programInfo.shortDescription" 
                        v-html="programInfo.shortDescription"
                    ></span>
                </div>
                
                <!-- DESCRIPTION -->

                <!-- TAGS -->
                <div class="text-center  pt-7" v-if="tags.length > 0">
                    <v-chip
                        class="ma-2"
                        v-for="tag in tags"
                        :key="tag.name"
                        :style="{ 'background-color': tag.color }"
                    >
                        {{ tag.name }}
                    </v-chip>
                </div>
                <!-- /TAGS -->

                <!-- STRENGTHS -->
                <div
                    v-if="strengths.length > 0"
                    class="pt-6"
                >
                    <v-row >
                        <v-col 
                            v-for="strength in strengths"
                            :key="strength"
                            class="py-0"
                            cols="auto"
                        >
                            <v-icon color="green">
                                icon-check
                            </v-icon>
                            <span class="ml-1 header-2">
                                {{ strength }}
                            </span>
                        </v-col >
                    </v-row>
                </div>
                <!-- /STRENGTHS -->

                <!-- AVAILABLE PLOTS -->
                <div
                    v-if="programInfo.availableLots && showPlotCount"
                    class="pt-6"
                >
                    <h4>
                        {{ $t("sidebar.program.availableLots") + ' (' + programInfo.availableLots + ')'}}
                    </h4>
                    <div class="pt-4">
                        <v-row no-gutters>
                            <v-col
                                v-for="typology in typologies"
                                :key="typology.name"
                                class="pb-4"
                                cols="12"
                            >
                                <v-card
                                    ref="stockCard"
                                    class="lot-card habiteo-body-2"
                                    :class="{ 'pl-0': typology.preview }"
                                    :height="60"
                                    elevation="4"
                                >
                                    <v-row no-gutters>
                                        <v-col
                                            v-if="typology.preview"
                                            cols="4"
                                            :style="{'height': '60px'}"
                                        >
                                            <v-img
                                                :src="typology.preview"
                                                :height="60"
                                            />
                                        </v-col>
                                        <v-col
                                            :class="{
                                                'col-8': typology.preview,
                                                'col-12': !typology.preview
                                            }"
                                        >
                                            <span
                                                class="d-flex justify-center align-center"
                                                :style="{'height': '60px'}"
                                            >
                                                {{typology.name + ' (' + typology.available + ')' }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <!-- /AVAILABLE PLOTS -->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "ProgramInfo",
        props:[
            'dialog',
        ],
        computed:{
            ...mapGetters(['programInfo']),
            ...mapGetters('widget', [
                'showPlotCount'
            ]),
            tags() {
                let tagList = [];
                for (let key in this.programInfo.tags)
                    if (this.programInfo.tags.hasOwnProperty(key)) {
                        const tag = this.programInfo.tags[key];
                        if (tag !== null)
                            tagList.push({
                                name: key,
                                color: tag.color,
                                type: tag.type
                            });
                    }
                return tagList;
            },
            typologies() {
                let typologyList = [];
                for (let key in this.programInfo.typologies)
                    if (this.programInfo.typologies.hasOwnProperty(key)) {
                        const typo = this.programInfo.typologies[key];
                        typologyList.push({
                            name: key,
                            available: typo.available,
                            preview: typo.preview
                        });
                    }
                return typologyList;
            },
            strengths() {
                let strengthList = [];
                for (let key in this.programInfo)
                    if (this.programInfo.hasOwnProperty(key)) {
                        const strength = this.programInfo[key];
                        if (key.startsWith("strength") && strength !== null && strength !== "")
                            strengthList.push(strength);
                    }
                return strengthList;
            }
        },
        methods: {
            toggleDialog(){
                this.$emit('close_program_info_dialog');
            }
        },  
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/program/components/ProgramInfo.vue